import { isNode } from '@xingternal/malt-util';

const nodeEnv = `${process.env.NODE_ENV}`.toLowerCase(); // eslint-disable-line
const isDevelopment = nodeEnv !== 'production' && nodeEnv !== 'test'; // eslint-disable-line
const hasConsole = isDevelopment && typeof console !== 'undefined';
const hasNotDebug = hasConsole && typeof console.debug !== 'function'; // eslint-disable-line
const logLevel = isNode || hasNotDebug ? 'log' : 'debug';
const getArgs = isNode ? (args) => ['content>'].concat(args) : (args) => args;

const log = hasConsole
  ? (...args) => {
      console[logLevel](...getArgs(args)); // eslint-disable-line
    }
  : () => undefined;

export default log;
